<div *ngIf="(isAuthenticated$ | async)?.isAuthenticated">
  <announcements-component ></announcements-component>
  <uploader-component (uploaded)="updateTableData()"></uploader-component>
  <data-table-component [activeFileRecordList]="activeFileRecordList" [previousFileRecordList]="previousFileRecordList" (updateTable)="updateTableData()"></data-table-component>
</div>

<div *ngIf="!(isAuthenticated$ | async)?.isAuthenticated">
  <guest-file-validation-component></guest-file-validation-component>
</div>
